module.exports = __webpack_public_path__ + "static/team-6-068f276a6d7944a166f69b6646f011ff.png";